/** Title case each whitespace-separated word (e.g. institution display names). */
export function toInstitutionTitleCase(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) {
    return value;
  }
  return trimmed
    .split(/\s+/)
    .map(word => {
      if (!word) {
        return word;
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
}
